<template>
  <div class="pages-init">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import { reportTTI, EHShow, getUrlQuery } from '@/common/utils';
import { PgyUtils } from '@fdfe/marketing-sdk';

export default {
  created() {
    this.setDupViewFlag();
    this.$bridge.subscribe('foreground', () => {
      this.closeDupView();
    });
    this.$bridge.subscribe('appear', () => {
      this.closeDupView();
    });
    // **********1. 页面created打点**********
    PgyUtils.reportPgyTTI('created');
  },
  mounted() {
    reportTTI();
    if (!window.location.href.includes('/activity.html')) {
      EHShow();
    }
    lx.pv('c_fsp_tech_mopfca3t', {
      from: env.from,
      page_path: window.location.pathname
    });
  },
  methods: {
    // 关闭多余的webView
    closeDupView() {
      if (this.isFromEcnyApp()) {
        return;
      }
      this.$bridge.getStorage('isTwoWebview', (res) => {
        const isTwoWebview = res && res.value;
        this.$bridge.clearStorage('isTwoWebview');
        if (isTwoWebview === 'true') {
          this.$bridge.closeWebview();
        }
      });
    },
    isFromEcnyApp() {
      const urlQuery = getUrlQuery();
      const openFromEcny = urlQuery && urlQuery.openFromEcny;
      if (openFromEcny) {
        return true;
      }
      return false;
    },
    setDupViewFlag() {
      if (!this.isFromEcnyApp()) {
        return;
      }
      // 标识来源于数币App并种localStorage
      this.$bridge.setStorage('isTwoWebview', 'true');
    }
  }
};
</script>
